import React from "react";
import {ListEditor} from "../../components/list-editor";
import * as yup from "yup";
import {
    SiteTag,
    SiteTagsQuery,
    useSiteTagsQuery,
    useUpdateSiteTagsMutation
} from "../../generated/graphql";
import {Tooltip} from "@mui/material";
import {useLocation} from "react-router";
import {FieldTableTitleTooltip} from "../../components/FieldTable/FieldTableTitleTooltip";
import {uniqueId} from "../../utils";


const columns = [{
    header: 'Section',
    accessor: 'section',
    dataType:'text',
}, {
    header: 'Name',
    accessor: 'name',
    dataType:'text',
}, {
    headerRaw:'Code',
    header: <Tooltip title="Used to identify tags on the server"><FieldTableTitleTooltip>Daybook code</FieldTableTitleTooltip></Tooltip>,
    accessor: 'code',
    dataType:'text',
}
];

function newRow():SiteTag {
    return {
        id: uniqueId(),
        name: '',
        section: '',
        code: ''
    }
}

const schema =  yup.array().of(
                yup.object().shape({
                    'section': yup.string().required(),
                    'name': yup.string().required()
                })
);

function getValues(data:SiteTagsQuery):SiteTag[] {
    return data?.siteTags?.data??[];
}

const SiteTags = ()=> {
    const url = useLocation().pathname;
    const query = useSiteTagsQuery();
    const [mutation,mutationResult] = useUpdateSiteTagsMutation();

    return (
        <ListEditor
           columns={columns}
           validationSchema={schema}
            title="Site Tags"
            permission="sitetags"
            query={query}
           saveResult={mutationResult}
           getValues={getValues}
           baseUrl={url}
           className="sites-tags"
            newRow={newRow}
            newRowLabel="Add Site Tag"
         mutation={mutation}
        />);
}

export default SiteTags;
